import * as React from 'react';
import { Input } from './styled';
import type { InputProps, InputRef } from 'antd';

export interface RuleValueInputProps extends Omit<InputProps, 'onChange'> {
  onChange?: (value: string) => void;
}

const RuleValueInput = React.forwardRef<InputRef, RuleValueInputProps>((props, ref) => {
  const { onChange, ...params } = props;
  const innerRef = React.useRef<InputRef>(null);

  React.useEffect(() => {
    innerRef.current?.focus();
  }, []);

  React.useImperativeHandle(ref, () => innerRef.current as InputRef, []);

  return (
    <Input
      variant="borderless"
      {...params}
      ref={innerRef}
      onBlur={(e) => {
        params.onBlur?.(e);
        onChange?.(e.target.value);
      }}
      onKeyDown={(e) => {
        props.onKeyDown?.(e);
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          onChange?.(e.currentTarget.value);
        }
      }}
    />
  );
});

RuleValueInput.displayName = 'RuleValueInput';

export default RuleValueInput;
